import React, { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TableSortLabel from "@mui/material/TableSortLabel";
import jsPDF from "jspdf";
import "jspdf-autotable";
import StatusChanger from "../status-chenger/index";

const DataTable = ({ data, setData, rowsPerPage, currentPage, status }) => {
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("");

  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const sortedData = [...data].sort((a, b) => {
    if (!orderBy) return 0;
    if (a[orderBy] < b[orderBy]) return order === "asc" ? -1 : 1;
    if (a[orderBy] > b[orderBy]) return order === "asc" ? 1 : -1;
    return 0;
  });

  const paginatedData = sortedData.slice(
    currentPage * rowsPerPage,
    currentPage * rowsPerPage + rowsPerPage
  );

  const exportPDF = () => {
    const doc = new jsPDF();
    doc.text("Search Result Table", 14, 10);
    doc.autoTable({
      startY: 20,
      head: [
        [
          "Order ID",
          "Panel URL",
          "Reading Status",
          "Reading Type",
          "Created At",
          "Days Subscription",
          "Active Start Date",
          "Days Active",
          "Status",
        ],
      ],
      body: sortedData.map((item) => [
        item?.request_id,
        item?.panel_url,
        item?.reading_services_status,
        item?.reading_services_type,
        item?.created_at,
        item?.count_days_subscriptions,
        item?.date_start_active,
        item?.count_days_active,
        item?.status,
      ]),
    });
    doc.save("search_result.pdf");
  };

  return (
    <>
      <div className="flex justify-end mb-4">
        <button
          className="px-4 py-2 bg-blue-600 text-white rounded-md"
          onClick={exportPDF}
        >
          Export PDF
        </button>
      </div>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow className="bg-primary">
              {[
                { label: "Order ID", key: "request_id" },
                { label: "Panel URL", key: "panel_url" },
                { label: "Reading Status", key: "reading_services_status" },
                { label: "Reading Type", key: "reading_services_type" },
                { label: "Created At", key: "created_at" },
                { label: "Days Subscription", key: "count_days_subscriptions" },
                { label: "Active Start Date", key: "date_start_active" },
                { label: "Days Active", key: "count_days_active" },
                { label: "Status", key: "status" },
              ].map((column) => (
                <TableCell
                  key={column.key}
                  align="center"
                  className="!text-darkTextColor whitespace-nowrap"
                  sortDirection={orderBy === column.key ? order : false}
                >
                  <TableSortLabel
                    active={orderBy === column.key}
                    direction={orderBy === column.key ? order : "asc"}
                    onClick={() => handleSort(column.key)}
                  >
                    {column.label}
                  </TableSortLabel>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedData.map((item) => (
              <TableRow
                key={item.id}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell align="center">{item?.request_id}</TableCell>
                <TableCell align="center">
                  <a
                    href={item?.panel_url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item?.panel_url}
                  </a>
                </TableCell>
                <TableCell align="center">
                  <span
                    className={`badge w-24 text-darkTextColor ${item?.reading_services_status === "success"
                      ? "bg-[#28a745]"
                      : "bg-[#ff6877]"
                      }`}
                  >
                    {item?.reading_services_status}
                  </span>
                </TableCell>
                <TableCell align="center">
                  {item?.reading_services_type}
                </TableCell>
                <TableCell align="center">{item?.created_at}</TableCell>
                <TableCell align="center">
                  {item?.count_days_subscriptions}
                </TableCell>
                <TableCell align="center">{item?.date_start_active}</TableCell>
                <TableCell align="center">
                  <div className={`w-full flex items-center justify-center`}>
                    {(() => {
                      const percentage =
                        (item?.count_days_active /
                          item?.count_days_subscriptions) *
                        100;
                      let bgColor;
                      if (percentage >= 80) {
                        bgColor = "bg-red-600";
                      } else if (percentage >= 65) {
                        bgColor = "bg-red-500";
                      } else if (percentage >= 50) {
                        bgColor = "bg-red-400";
                      } else {
                        bgColor = undefined;
                      }

                      return (
                        <span
                          className={`w-fit p-2 font-bold rounded-md ${bgColor
                            ? `${bgColor} text-darkTextColor`
                            : "bg-transparent"
                            }`}
                        >
                          {item?.count_days_active}
                        </span>
                      );
                    })()}
                  </div>
                </TableCell>
                <TableCell align="center">
                  <StatusChanger
                    data={item}
                    setData={setData}
                    rowsPerPage={rowsPerPage}
                    currentPage={currentPage}
                    status={status}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default DataTable;